import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSetUser } from "../../contexts/UserContext";
import { useSetUserRegistration } from "../../contexts/UserRegistrationContext";
import style from "./launchPage.module.css";
import axios from 'axios';
import { _axios } from "../../utils/axios";
import { BASE_URL } from "../../constants/Constants";
import { ErrorToast, SuccessToast } from "../../components/toastMessage";
/**
 * Before: the old module pictures, shown on the launch page cards.
 * import BPMS from "../../assets/BPMS.jpeg";
 * import Water from "../../assets/WaterSupplyManagement.jpeg";
 * import Tax from "../../assets/TaxManagement.jpeg";
 * import Trade from "../../assets/TradeManagement.png";
 * import StreetLight from "../../assets/StreetLightManagement.jpeg";
 * import Sanitation from "../../assets/sanitation.png";
 * import Road from "../../assets/RoadOpen SpaceManagement.jpeg";
 * import PublicSecurity from "../../assets/PublicSecurityStrayAnimals Management.jpg";
 * import Notice from "../../assets/IssuingNoticesOnNegligence.jpeg";
 * import Disease from "../../assets/HarmfulDiseasesPrevention.jpg";
 * import Govt from "../../assets/GovtSchemes.jpg";
 * import Birth from "../../assets/Birth Certificate.jpeg";
 * import Assest from "../../assets/Assests Management.jpeg";
 * import Degree from "../../assets/360-DegreeReporting.png";
 */
import LandRegularization from "../../assets/modules/land-regularization.webp";
import { cookieUtils } from "../../utils/cookieUtils";
import { fetchAndVerifyUserDetails } from "../../libs/jwtUtils";
/**
 * A card the org can buy, shown greyed out under "Purchase below Modules".
 * The cards come from cp_launch_modules (GET /api/launch-modules), so they
 * change with SQL, not a code change.
 * BEFORE: a fixed PURCHASABLE_MODULES list here with images from
 * src/assets/modules (Disaster Management, Human - Wildlife Conflict,
 * AI Knowledge Library, Citizen Complaint).
 */
type TLaunchModule = { id: number; title: string; description: string | null; image_url: string | null };

/** A path served by the backend (e.g. /public/launch-modules/x.webp) gets the backend address in front. */
const moduleImageUrl = (url: string | null) =>
    !url ? "" : /^https?:\/\//i.test(url) ? url : `${BASE_URL}${url}`;

const LaunchPage = () => {
    const setUser = useSetUser()
    const setUserRegistration = useSetUserRegistration()
    const [showPassword, setShowPassword] = useState(false);
    const [purchasableModules, setPurchasableModules] = useState<TLaunchModule[]>([]);

    useEffect(() => {
        _axios.get(`${BASE_URL}/api/launch-modules`)
            .then((response) => setPurchasableModules(response?.data?.data ?? []))
            .catch((error) => console.log("Could not load launch modules", error));
    }, []);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [token, setToken] = useState('');
    const navigate = useNavigate();
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    // const isUserLogin = async () => {
    //     const userDetails = await localStorage.getItem('userDetails');
    //     if (userDetails === null) {
    //         navigate('/onboarding/login');
    //     }
    // }
    const isUserLogin = () => {
        const userDetails = cookieUtils.getSecureCookie('userDetails');
        console.log("userDetails Cookies", userDetails);
        if (!userDetails) {
            navigate('/onboarding/login');
        }
    }

    useEffect(() => {
        isUserLogin();
    }, [navigate]);

    const handleImageClick = async () => {
        // Get user details and roles from localStorage
        // const userDetailsString = localStorage.getItem('userDetails');
        // const userRegistrationDetailsString = localStorage.getItem('userRegestrationDetails');

        const userDetails = cookieUtils.getSecureCookie('userDetails');
        const userRegistrationDetails = cookieUtils.getSecureCookie('userRegistrationDetails');

        // Check if the retrieved strings are not null before parsing them
        // const userDetails = userDetailsString ? JSON.parse(userDetailsString) : null;
        // const userRegistrationDetails = userRegistrationDetailsString ? JSON.parse(userRegistrationDetailsString) : null;

        if (userDetails?.role === 'System Admin') {
            // SuccessToast('Login Successfully')
            navigate('/dashboard');
        }
        else if (userDetails?.role === 'Level 1') {
            // SuccessToast('Login Successfully')
            navigate('/level-1-dashboard');
        }
        else if (userDetails?.role === 'Level 2') {
            // SuccessToast('Login Successfully')
            navigate('/level-2-dashboard');
        }
        else if (userDetails?.role === 'Level 3') {
            // SuccessToast('Login Successfully')
            navigate('/level-three-dashboard');
        }
        // else {
        //     _axios.post(`${BASE_URL}/api/user-details/details`,
        //         {
        //             "user_id": userDetails?.user_id
        //         })
        //         .then(function (details) {
        //             debugger
        //             const userDetails = details?.data?.data?.[0]
        //             console.log('response', details)
        //             // SuccessToast('Login Successfully')

        //             if (details.data.data.length === 0) {
        //                 navigate('/onboarding/verification-page');
        //             } else {
        //                 localStorage.setItem('userRegestrationDetails', JSON.stringify(userDetails))
        //                 setUserRegistration(userDetails)
        //                 if (userDetails.regestration_status == 1)
        //                     navigate('/user-applications')
        //                 else navigate('/user-account-not-verified');
        //             }
        //         }).catch(function (error) {
        //             // handle error
        //             debugger
        //             console.log(error);
        //         })
        //     console.log('response?.data?.data', userDetails?.data)

        // }

        else {


            // 1️⃣ Fetch, Validate & Decode User Token
            let userDetailsResponse = await fetchAndVerifyUserDetails(userDetails?.user_id);

            console.log("User Details Response:", userDetailsResponse);

            // 2️⃣ Check if User Details Exist or are Empty
            if (!userDetailsResponse?.data?.data || Object.keys(userDetailsResponse.data?.data).length === 0) {
                console.warn("Invalid or empty user details. Redirecting to verification...");
                navigate("/onboarding/verification-page");
                return;
            }

            // 3️⃣ If Token Validation Failed, Ensure `regestration_status = 0`
            if (!userDetailsResponse.success) {
                alert("Something wrong with token")
                return
            }

            // 4️⃣ Extract Valid User Details
            const data = userDetailsResponse.data?.data;

            // 5️⃣ Store User Details Securely in Cookies
           cookieUtils.setSecureCookie("userRegistrationDetails", data, { expires: 7 });
            localStorage.setItem('userRegestrationDetails', JSON.stringify(data))
            setUserRegistration(data);
            
            // 6️⃣ Navigate Based on Registration Status
            if (data.regestration_status === 1) {
                navigate('/user-applications')
            } else {
                navigate('/user-account-not-verified');
            }
        }
    };

    const handleDefaultUserNavigation = async (userDetails: any) => {
        try {
            const response = await _axios.post(`${BASE_URL}/api/user-details/details`, {
                "user_id": userDetails?.user_id
            });

            const fetchedUserDetails = response?.data?.data?.[0];

            if (!response.data.data.length) {
                navigate('/onboarding/verification-page');
                return;
            }

            cookieUtils.setSecureCookie('userRegistrationDetails', fetchedUserDetails, { expires: 7 });
            setUserRegistration(fetchedUserDetails);

            if (fetchedUserDetails.regestration_status === 1) {
                navigate('/user-applications');
            } else {
                navigate('/user-account-not-verified');
            }
        } catch (error) {
            console.error('Error fetching user details:', error);
            ErrorToast('Failed to fetch user details');
        }
    };

    return (
        <div className={style.body}>
            <div className={style.divbodyheading}>
                <p className={`${style.bodytitle} text-start`}>Modules Activated for your Org.</p>
            </div>

            <div className={`row`}>
                <div className={'col-12 col-md-3 col-lg-2'}>
                    <div className={`border-1`}>
                        <div className={`${style.card} p-3 m-2 cursor-pointer`} onClick={handleImageClick}>
                            {/* Before: the BPMS picture, "Building/Land Development Management" and
                                "Simplifying the land development and construction processes to promote effective urban expansion." */}
                            <img src={LandRegularization}
                                alt="Land Regularization (Gunthewari)"
                                className={style.imgClass}
                            />
                            <figcaption className={style.figcaption}> Land Regularization (Gunthewari) </figcaption>
                            <div className={style.hoverInfo}>A robust digital platform for seamless Gunthewari approvals, reducing manual errors and ensuring faster processing with real-time tracking and document management.</div>
                        </div>
                    </div>
                </div>
            </div>
            <p className={`${style.titleProd} text-start p-1 mt-8`}>Purchase below Modules</p>
            <div className={style.lineContainer} >


                {/* Before: eleven greyed cards - Water Supply, Tankers & Bill Management; Tax Management;
                    Certificate Process Management; Trade & Business Management; Sanitation Management;
                    Street Light & Roads Management; Assets, Funds & Contracts Management; Roads and Open Spaces
                    Management; Public Security & Stray Animals Management; Harmful Diseases Control and
                    Prevention; Issuing Notices for Negligence and Recovery. */}
                <div className={`row`}>
                    {purchasableModules.map((module) => (
                        <div key={module.id} className={'col-12 col-md-3 col-lg-2'}>
                            <div className={`border-1`}>
                                <div className={`${style.card} p-3 m-2 cursor-arrow`} style={{ backgroundColor: "#EEEEEE" }}>
                                    <img src={moduleImageUrl(module.image_url)}
                                        alt={module.title}
                                        className={style.imgClass}
                                    />
                                    <figcaption className={style.figcaption}> {module.title} </figcaption>
                                    <div className={style.hoverInfo}>{module.description}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div >
        </div >
    );
};

export default LaunchPage;
